<div class="form-floating d-flex align-items-center position-relative">
  <input
    [attr.aria-describedby]="ariaDescribedBy || null"
    [attr.aria-invalid]="!isValid"
    [attr.avoidCopyPaste]="inputElem.avoidCopyPaste || false"
    [attr.data-test]="'form-input-' + inputElem.name"
    [attr.disabled]="inputElem.isDisabled ? '' : null"
    [attr.readonly]="isLoading || inputElem.isReadonly ? 'true' : null"
    [attr.id]="inputElem.name"
    [attr.name]="inputElem.name"
    [attr.placeholder]="inputElem.placeholder | translate"
    [formControl]="parentForm.controls[inputElem.name]"
    [mweBlockPasteEvent]="inputElem.avoidCopyPaste"
    [mweInputKeyDirective]="inputElem.directiveType"
    [ngClass]="{
      'is-invalid':
        !inputElem.datepickerConfig.readonly && parentForm.controls[inputElem.name].errors && !parentForm.controls[inputElem.name].pristine,
      'bg-transparent': inputElem.datepickerConfig.readonly,
    }"
    class="form-control datetimepicker-input"
    type="text"
  />
  @if (inputElem.labelKey) {
    <label [attr.for]="inputElem.name" [ngClass]="inputElem.labelCss" [translate]="inputElem.labelKey" class="form-label"></label>
  }
  <div class="form-floating-icon">
    <button
      (click)="openDatepicker(inputElem.datepickerConfig, $event)"
      [attr.aria-label]="'global.datepicker.toggleButton' | translate"
      [attr.data-test]="'form-input-' + inputElem.name + '-datepicker'"
      type="button"
      class="btn btn-clean"
    >
      <i class="far fa-calendar-alt"></i>
    </button>
  </div>
</div>
